<template>
  <div>
    <h2 class="text-center">Stitched MCQ Questions</h2>
    <router-link
      class="bg-green text-white btn p-3 mb-2 px-6 inline-block no-underline rounded-full"
      to="/mcq-stitcher-add/"
    >
      Create Stitched MCQ
    </router-link>
    <div class="flex my-2 text-center font-bold text-gray-300">
      <label style="flex-shrink:0" class="mr-4"
        >Filter by question tag id</label
      >
      <div class="flex flex-row w-full">
        <VueSelect
          v-model="search_by_qtag"
          :options="tagOptions"
          label="name"
          class="w-full"
          placeholder="Select question tag id"
          @input="handleInput"
        />
      </div>
    </div>
    <Table ref="edTable" :endpoint="endpoint" :tableConfig="tableConfig">
      <template #row="{row}">
        <td>{{ row.name || row.content }}</td>
        <td>{{ row.id }}</td>
        <td>{{ formatDate(row.created_on) }}</td>
        <td>{{ formatDate(row.updated_on) }}</td>
        <td>{{ row.points }}</td>
        <td>{{ getSubmissionCasesCount(row.list) }}</td>
        <td>
          <router-link :to="{ name: 'MCQStitcherEdit', params: { id: row.id } }"
            >Edit</router-link
          >
        </td>
        <td>
          <button
            class="text-blue rounded-none hover:bg-blue focus:bg-blue active:bg-blue hover:text-white active:text-white focus:text-white flex justify-center items-center"
            @click="duplicate(row.id)"
          >
            <i class="material-icons cursor-pointer">file_copy</i>
          </button>
        </td>
      </template>
    </Table>
    <div class="small-12 columns mb-8"></div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"
import { getDateTimeFormat } from "@/utils/dateTimeUtils"
import { duplicateStitchedMCQ } from "@/apis/stitchedMCQ"
import Table from "@/components/DataTable/Table"

export default {
  components: {
    VueSelect,
    Table,
  },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}admin/questions?search_by_type=0&fields=id,type,name,list,points,qtags,content,explain,created_on,updated_on`,
      search_by_qtag: "",
      tagOptions: [],
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "/",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          path: "updated_on",
        },
        {
          header: { textContent: "Pts", sortingParam: "points" },
          path: "points",
        },
        {
          header: { textContent: "No. of<br/>Ques." },
          path: "list",
        },
        {
          header: { textContent: "Option" },
          path: "id",
        },
        {
          header: { textContent: "Duplicate" },
          path: "id",
        },
      ],
    }
  },
  created() {
    this.populateTags()
  },
  methods: {
    handleInput(data) {
      const payload = { key: "search_by_qtagid", value: "" }
      if (data) {
        payload.value = data.id
        this.$refs.edTable.updateRoute(payload)
      }
      this.$refs.edTable.updateRoute(payload)
    },
    async duplicate(id) {
      try {
        const res = await duplicateStitchedMCQ(id)
        this.$refs.edTable.getItems()
        const action = await this.$swal({
          icon: "success",
          text: "Stitched MCQ duplicated",
          buttons: {
            cancel: "Cancel",
            confirm: "Edit",
          },
        })
        if (!action) return
        this.$router.push({
          name: "MCQStitcherEdit",
          params: { id: res.data.duplicateStitchedMcq },
        })
      } catch (err) {
        console.error(err)
        this.$noty.error("Failed to duplicate the stitched MCQ")
      }
    },
    populateTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          const tags = res.data.items
          this.tagOptions = tags.map(item => ({ id: item.id, name: item.name }))
        })
        .catch(err => console.error(err))
    },
    formatDate(date) {
      return getDateTimeFormat(date)
    },
    getSubmissionCasesCount(list) {
      list = JSON.parse(list) || []
      if (list.questions) {
        return list.questions.length
      }
      return 0
    },
  },
}
</script>
